import { Component, Input } from '@angular/core';
import { Exception, PaymentHistoryResponse } from '@cargos/sprintpay-models';
import { finalize, take } from 'rxjs';
import { PaymentsFacilityService } from 'src/app/shared/services/payments.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-download-confirmation-icon',
    templateUrl: './download-confirmation-icon.component.html',
    styleUrls: ['./download-confirmation-icon.component.scss'],
    standalone: false,
})
export class DownloadConfirmationIconComponent {
    public downloading = false;

    @Input() payment: PaymentHistoryResponse;

    constructor(private paymentsFacilityService: PaymentsFacilityService) {}

    downloadConfirmation(): void {
        this.downloading = true;
        const ids = this.payment.invoice?.id ? [this.payment.invoice?.id] : [];

        this.paymentsFacilityService
            .getReceiptByPost(ids, this.payment.invoice?.confirmationId || '')
            .pipe(
                take(1),
                finalize(() => (this.downloading = false))
            )
            .subscribe({
                error: (error: Exception) => {
                    Swal.fire({
                        title: error.title,
                        text: error.description,
                        icon: error.type,
                    });
                },
            });
    }
}
